import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import { SUBSCRIPTION_TYPES } from './constants';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../../../firebase/config';
import './dialogs.css';

const DeactivateDialog = ({ 
  open, 
  onClose, 
  onSubmit, 
  selectedUser,
  selectedSubscriptionType
}) => {
  const subscriptionInfo = SUBSCRIPTION_TYPES[selectedSubscriptionType.toUpperCase()];
  const currentSubscription = selectedUser?.subscriptions[selectedSubscriptionType];

  // # Get mentor display information
  const getMentorDisplay = () => {
    const mentor = currentSubscription?.mentor;
    if (!mentor) return 'None';
    if (mentor === 'none') return 'None';
    if (typeof mentor === 'string') return mentor;
    if (typeof mentor === 'object' && mentor.name) {
      return `${mentor.name} (${mentor.email})`;
    }
    return 'None';
  };

  // # Handle deactivation with batch write
  const handleDeactivate = () => {
    // # Prepare data for batch write in subscription_management.js
    const now = new Date().toISOString();
    const updateData = {
      ...currentSubscription,
      status: 'inactive',
      endDate: now
    };
    
    // # Create notification for the subscription deactivation
    const createNotification = httpsCallable(functions, 'createSubscriptionNotification');
    createNotification({
      uid: selectedUser.uid,
      subscriptionType: selectedSubscriptionType,
      startDate: currentSubscription.startDate,
      endDate: now,
      action: 'deactivate'
    })
    .then(notificationResult => {
      console.log('Subscription deactivation notification sent:', notificationResult.data);
    })
    .catch(error => {
      console.error('Error sending subscription deactivation notification:', error);
    });
    
    // # Pass the update data to parent component for batch processing
    onSubmit(updateData);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="dialog-title">
        Deactivate {subscriptionInfo.name}
        {selectedUser && (
          <Typography variant="subtitle2" className="dialog-subtitle">
            for {selectedUser.userName}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent className="dialog-content">
        <Typography className="warning-text">
          This will immediately end the subscription. This action cannot be undone.
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Current subscription: {subscriptionInfo.name}
          <br />
          Current status: {currentSubscription?.status || 'N/A'}
          <br />
          End date: {currentSubscription?.endDate ? new Date(currentSubscription.endDate).toLocaleDateString() : 'N/A'}
          {subscriptionInfo.requiresMentor && (
            <>
              <br />
              Mentor: {getMentorDisplay()}
            </>
          )}
        </Typography>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button onClick={onClose} color="inherit">
          Keep Active
        </Button>
        <Button 
          onClick={handleDeactivate} 
          variant="contained" 
          color="error"
          disabled={currentSubscription?.status !== 'active'}
        >
          Deactivate Now
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeactivateDialog;
